/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
class SwymWishlist extends HTMLElement {
  constructor() {
    super();
    this.elm = this;

    this.wishlistContainer = null;
    this.wishlistCountElements = null;
    this.cartDrawer = null;
    this.tabHeadings = null;
    this.renderTimeout = null;

    this.debouncedRenderWishlist = this.debounce(this.renderWishlist.bind(this), 300);

    this.productCardMarkup = `<div class="swym-wishlist-grid cart-items">
	  <table class="cart-items" role="table">
		<tbody role="rowgroup">
		  {{#products}}
		  <tr id="SwymWishlist-Item-{{empi}}" class="cart-item swym-wishlist-item" role="row">
			<td class="cart-item__media" role="cell">
			  <a href="{{du}}" class="cart-item__link swym-is-anchor" tabindex="-1" aria-hidden="true"> </a>
			  <div class="cart-item__picture">
				<img alt="{{dt}}" class="swym-wishlist-image cart-item__image" src="{{iu}}" loading="lazy" width="150">
			  </div>
			</td>

			<td class="cart-item__details" role="cell">
			  <div class="cart-item__details__name">
				<a href="{{du}}" aria-label="{{dt}}" class="swym-is-anchor cart-item__name break">
				  <div class="swym-title swym-title-1">
					{{dt}}
				  </div>
				</a>
			  </div>
			  <div class="cart-item__details__content">
        <div class="swym-product-price swym-text swym-text-1 cart-item__price-wrapper">
				  <span class="price swym-product-final-price swym-value">
					  {{cu}}{{pr}}
				  </span>
				</div>
				<div class="hidden swym-variant-title swym-text swym-title-2 swym-variant-title-spacer cart-item__options">
				  <div class="cart-item__options__item">
					<dl>
					  {{{variantinfo}}}
					</dl>
				  </div>
				</div>
			  </div>
			</td>

			<td class="cart-item__quantity" role="cell">
			  <div class="cart-item__quantity-wrapper">
          <div class="cart-item__actions">
            <a class="cart-item__button cart-item__button-add" href="{{du}}">
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_11491_111321)">
                <path d="M17.0623 4.54647H16.024C15.7069 1.98577 13.5747 0 11 0C8.42529 0 6.29343 1.98577 5.976 4.54647H4.93766C3.86915 4.54647 3 5.44026 3 6.53905V19.0074C3 20.1062 3.86915 21 4.93766 21H17.0623C18.1309 21 19 20.1062 19 19.0074V6.53905C19 5.44026 18.1309 4.54647 17.0623 4.54647ZM11 1.32385C12.8634 1.32385 14.4159 2.7188 14.7223 4.54647H7.2777C7.58409 2.7188 9.13664 1.32385 11 1.32385ZM17.7126 19.0074C17.7126 19.3762 17.421 19.6762 17.0623 19.6762H4.93766C4.57903 19.6762 4.28736 19.3762 4.28736 19.0074V6.53905C4.28736 6.17026 4.57903 5.87032 4.93766 5.87032H17.0623C17.421 5.87032 17.7126 6.17026 17.7126 6.53905V19.0074Z" fill="#242423"/>
                </g>
                <defs>
                <clipPath id="clip0_11491_111321">
                <rect width="16" height="21" fill="white" transform="translate(3)"/>
                </clipPath>
                </defs>
              </svg>
            </a>
            <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="hidden swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button btn--filled">
            </button>
            <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button cart-remove-button">
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7188 4.10156H14.2734V3.28125C14.2734 2.80262 14.0833 2.34359 13.7449 2.00514C13.4064 1.6667 12.9474 1.47656 12.4688 1.47656H8.53125C8.05262 1.47656 7.59359 1.6667 7.25514 2.00514C6.9167 2.34359 6.72656 2.80262 6.72656 3.28125V4.10156H3.28125C3.15071 4.10156 3.02552 4.15342 2.93322 4.24572C2.84092 4.33802 2.78906 4.46321 2.78906 4.59375C2.78906 4.72429 2.84092 4.84948 2.93322 4.94178C3.02552 5.03408 3.15071 5.08594 3.28125 5.08594H4.10156V17.0625C4.10156 17.3671 4.22256 17.6592 4.43793 17.8746C4.65331 18.0899 4.94542 18.2109 5.25 18.2109H15.75C16.0546 18.2109 16.3467 18.0899 16.5621 17.8746C16.7774 17.6592 16.8984 17.3671 16.8984 17.0625V5.08594H17.7188C17.8493 5.08594 17.9745 5.03408 18.0668 4.94178C18.1591 4.84948 18.2109 4.72429 18.2109 4.59375C18.2109 4.46321 18.1591 4.33802 18.0668 4.24572C17.9745 4.15342 17.8493 4.10156 17.7188 4.10156ZM7.71094 3.28125C7.71094 3.06369 7.79736 2.85504 7.9512 2.7012C8.10504 2.54736 8.31369 2.46094 8.53125 2.46094H12.4688C12.6863 2.46094 12.895 2.54736 13.0488 2.7012C13.2026 2.85504 13.2891 3.06369 13.2891 3.28125V4.10156H7.71094V3.28125ZM15.9141 17.0625C15.9141 17.106 15.8968 17.1477 15.866 17.1785C15.8352 17.2093 15.7935 17.2266 15.75 17.2266H5.25C5.20649 17.2266 5.16476 17.2093 5.13399 17.1785C5.10322 17.1477 5.08594 17.106 5.08594 17.0625V5.08594H15.9141V17.0625ZM9.02344 8.53125V13.7812C9.02344 13.9118 8.97158 14.037 8.87928 14.1293C8.78698 14.2216 8.66179 14.2734 8.53125 14.2734C8.40071 14.2734 8.27552 14.2216 8.18322 14.1293C8.09092 14.037 8.03906 13.9118 8.03906 13.7812V8.53125C8.03906 8.40071 8.09092 8.27552 8.18322 8.18322C8.27552 8.09092 8.40071 8.03906 8.53125 8.03906C8.66179 8.03906 8.78698 8.09092 8.87928 8.18322C8.97158 8.27552 9.02344 8.40071 9.02344 8.53125ZM12.9609 8.53125V13.7812C12.9609 13.9118 12.9091 14.037 12.8168 14.1293C12.7245 14.2216 12.5993 14.2734 12.4688 14.2734C12.3382 14.2734 12.213 14.2216 12.1207 14.1293C12.0284 14.037 11.9766 13.9118 11.9766 13.7812V8.53125C11.9766 8.40071 12.0284 8.27552 12.1207 8.18322C12.213 8.09092 12.3382 8.03906 12.4688 8.03906C12.5993 8.03906 12.7245 8.09092 12.8168 8.18322C12.9091 8.27552 12.9609 8.40071 12.9609 8.53125Z" fill="black"></path>
              </svg>
            </button>
          </div>
			  </div>
			</td>
		  </tr>
		  {{/products}}
		</tbody>
	  </table>
	</div>`;
  }

  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  connectedCallback() {
    this.boundRenderWishlist = this.debouncedRenderWishlist;

    if (window.SwymCallbacks && typeof window.SwymCallbacks.push === 'function') {
      window.SwymCallbacks.push(this.boundRenderWishlist);
    }

    this.setupCartDrawerObserver();

    requestIdleCallback(
      () => {
        this.initCartDrawerTabs();

        if (window._swat && window._swat.persistedData) {
          const count = window._swat.persistedData.upi.length;
          if (!this.wishlistCountElements) {
            this.wishlistCountElements = document.querySelectorAll('.js-wishlist-count');
          }
          this.wishlistCountElements.forEach((el) => {
            el.textContent = count;
          });
        }
      },
      { timeout: 500 }
    );
  }

  initCartDrawerTabs() {
    if (typeof window.cartDrawerTabClickHandler === 'function') {
      if (!this.tabHeadings) {
        this.tabHeadings = document.querySelectorAll('.js-drawer-heading');
      }

      this.tabHeadings.forEach(function (heading) {
        heading.removeEventListener('click', window.cartDrawerTabClickHandler);
        heading.addEventListener('click', window.cartDrawerTabClickHandler, { passive: true });
      });

      const event = new CustomEvent('cart-drawer:updated');
      document.dispatchEvent(event);
    } else {
      console.warn('Global tab handler not found. Make sure cart-drawer-tabs.js is loaded correctly.');
    }

    const cartWishlist = document.querySelector('#cart-wishlist');
    if (cartWishlist && !cartWishlist.classList.contains('hidden') && window._swat) {
      requestIdleCallback(
        () => {
          window.swymRenderWishlist(window._swat);
        },
        { timeout: 300 }
      );
    }
  }

  setupCartDrawerObserver() {
    if (!this.cartDrawer) {
      this.cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
    }

    if (this.cartDrawer) {
      this.observeCartDrawer(this.cartDrawer);
    } else {
      const bodyObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            this.cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
            if (this.cartDrawer) {
              this.observeCartDrawer(this.cartDrawer);
              bodyObserver.disconnect();
              break;
            }
          }
        }
      });

      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  observeCartDrawer(cartDrawer) {
    let observerTimeout;

    const cartObserver = new MutationObserver((mutations) => {
      clearTimeout(observerTimeout);

      observerTimeout = setTimeout(() => {
        if (!this.wishlistContainer) {
          this.wishlistContainer = document.getElementById('wishlist-items-container');
        }

        let cartChanged = false;
        for (const mutation of mutations) {
          if (mutation.type === 'childList' || (mutation.type === 'attributes' && mutation.attributeName === 'class')) {
            cartChanged = true;
            break;
          }
        }

        if (cartChanged) {
          if (this.wishlistContainer) {
            this.wishlistContainer.classList.remove('wishlist-rendered');
          }

          if (window._swat) {
            requestIdleCallback(
              () => {
                this.debouncedRenderWishlist(window._swat);

                if (typeof window.cartDrawerTabClickHandler === 'function') {
                  const event = new CustomEvent('cart-drawer:updated');
                  document.dispatchEvent(event);
                }
              },
              { timeout: 300 }
            );
          }
        } else if (this.wishlistContainer && !this.wishlistContainer.classList.contains('wishlist-rendered')) {
          if (window._swat) {
            this.debouncedRenderWishlist(window._swat);
          }
        }
      }, 100);
    });

    cartObserver.observe(cartDrawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-cart-updated', 'data-cart-count'],
    });
  }

  getVariantInfo(variants) {
    try {
      const variantData = variants && variants != '[]' ? JSON.parse(variants)[0] : null;
      let variantinfo = '';

      if (variantData) {
        const variantKeys = Object.keys(variantData);
        if (variantKeys.length > 0) {
          // Skip if it's just Default Title
          if (variantKeys.length === 1 && variantKeys[0] === 'Default Title') {
            return '';
          }

          // Format similar to cart-item: "OPTION_NAME: option_value"
          variantinfo = variantKeys
            .map((key) => {
              return `<div class="product-option size-option"><dt>${key.toUpperCase()}:</dt><dd>${
                variantData[key]
              }</dd></div>`;
            })
            .join('');
        }
      }

      return variantinfo;
    } catch (err) {
      return variants;
    }
  }

  onAddToCartClick(e) {
    e.preventDefault();
    const productId = e.currentTarget.getAttribute('data-product-id');
    const variantId = e.currentTarget.getAttribute('data-variant-id');
    const du = e.currentTarget.getAttribute('data-product-url');
    e.currentTarget.innerHTML =
      '<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_11491_111321)"><path d="M17.0623 4.54647H16.024C15.7069 1.98577 13.5747 0 11 0C8.42529 0 6.29343 1.98577 5.976 4.54647H4.93766C3.86915 4.54647 3 5.44026 3 6.53905V19.0074C3 20.1062 3.86915 21 4.93766 21H17.0623C18.1309 21 19 20.1062 19 19.0074V6.53905C19 5.44026 18.1309 4.54647 17.0623 4.54647ZM11 1.32385C12.8634 1.32385 14.4159 2.7188 14.7223 4.54647H7.2777C7.58409 2.7188 9.13664 1.32385 11 1.32385ZM17.7126 19.0074C17.7126 19.3762 17.421 19.6762 17.0623 19.6762H4.93766C4.57903 19.6762 4.28736 19.3762 4.28736 19.0074V6.53905C4.28736 6.17026 4.57903 5.87032 4.93766 5.87032H17.0623C17.421 5.87032 17.7126 6.17026 17.7126 6.53905V19.0074Z" fill="#242423"/></g><defs><clipPath id="clip0_11491_111321"><rect width="16" height="21" fill="white" transform="translate(3)"/></clipPath></defs></svg>';

    const self = this;
    const button = e.currentTarget;

    window._swat.replayAddToCart(
      {
        empi: productId,
        du: du,
      },
      variantId,
      function (c) {
        button.innerHTML =
          '<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_11491_111321)"><path d="M17.0623 4.54647H16.024C15.7069 1.98577 13.5747 0 11 0C8.42529 0 6.29343 1.98577 5.976 4.54647H4.93766C3.86915 4.54647 3 5.44026 3 6.53905V19.0074C3 20.1062 3.86915 21 4.93766 21H17.0623C18.1309 21 19 20.1062 19 19.0074V6.53905C19 5.44026 18.1309 4.54647 17.0623 4.54647ZM11 1.32385C12.8634 1.32385 14.4159 2.7188 14.7223 4.54647H7.2777C7.58409 2.7188 9.13664 1.32385 11 1.32385ZM17.7126 19.0074C17.7126 19.3762 17.421 19.6762 17.0623 19.6762H4.93766C4.57903 19.6762 4.28736 19.3762 4.28736 19.0074V6.53905C4.28736 6.17026 4.57903 5.87032 4.93766 5.87032H17.0623C17.421 5.87032 17.7126 6.17026 17.7126 6.53905V19.0074Z" fill="#242423"/></g><defs><clipPath id="clip0_11491_111321"><rect width="16" height="21" fill="white" transform="translate(3)"/></clipPath></defs></svg>';
        button.setAttribute('data-state-cart', 'swym-added');

        if (window._swat) {
          setTimeout(() => {
            window._swat.fetch(function (products) {
              self.renderWishlist(window._swat);
              self.initCartDrawerTabs();
            });
          }, 500);
        }
      },
      function (error) {
        button.innerHTML =
          '<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_11491_111321)"><path d="M17.0623 4.54647H16.024C15.7069 1.98577 13.5747 0 11 0C8.42529 0 6.29343 1.98577 5.976 4.54647H4.93766C3.86915 4.54647 3 5.44026 3 6.53905V19.0074C3 20.1062 3.86915 21 4.93766 21H17.0623C18.1309 21 19 20.1062 19 19.0074V6.53905C19 5.44026 18.1309 4.54647 17.0623 4.54647ZM11 1.32385C12.8634 1.32385 14.4159 2.7188 14.7223 4.54647H7.2777C7.58409 2.7188 9.13664 1.32385 11 1.32385ZM17.7126 19.0074C17.7126 19.3762 17.421 19.6762 17.0623 19.6762H4.93766C4.57903 19.6762 4.28736 19.3762 4.28736 19.0074V6.53905C4.28736 6.17026 4.57903 5.87032 4.93766 5.87032H17.0623C17.421 5.87032 17.7126 6.17026 17.7126 6.53905V19.0074Z" fill="#242423"/></g><defs><clipPath id="clip0_11491_111321"><rect width="16" height="21" fill="white" transform="translate(3)"/></clipPath></defs></svg>';

        if (window._swat) {
          self.renderWishlist(window._swat);
          self.initCartDrawerTabs();
        }
      }
    );
  }

  onRemoveBtnClick(e) {
    e.preventDefault();
    const epi = +e.currentTarget.getAttribute('data-variant-id');
    const empi = +e.currentTarget.getAttribute('data-product-id');
    const self = this;

    window._swat.fetch(function (products) {
      products.forEach(function (product) {
        if (epi && empi && product.epi == epi && product.empi == empi) {
          window._swat.removeFromWishList(product, function () {
            if (!window.SwymCallbacks) {
              window.SwymCallbacks = [];
            }
            self.renderWishlist(window._swat);
            self.initCartDrawerTabs();
          });
        }
      });
    });
  }

  renderWishlist(swat) {
    swat.fetch((products) => {
      if (!this.wishlistContainer) {
        this.wishlistContainer = document.getElementById('wishlist-items-container');
      }

      if (!this.wishlistContainer) {
        return;
      }

      const count = products ? products.length : 0;

      if (!this.wishlistCountElements) {
        this.wishlistCountElements = document.querySelectorAll('.js-wishlist-count');
      }

      this.wishlistCountElements.forEach((el) => {
        el.textContent = count;
      });

      if (!products || products.length === 0) {
        requestAnimationFrame(() => {
          this.wishlistContainer.innerHTML = `
          <div class="swym-wishlist-grid cart-items">
            <div class="empty-wishlist">
              <p>You don't have any products in your wishlist yet.</p>
            </div>
          </div>`;
          this.wishlistContainer.classList.add('wishlist-rendered');
        });
        return;
      }

      const formattedWishlistedProducts = products.map((p) => {
        p = SwymUtils.formatProductPrice(p);
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
        p.variantinfo = p.vi ? this.getVariantInfo(p.vi) : '';
        return p;
      });

      const productCardsMarkup = SwymUtils.renderTemplateString(this.productCardMarkup, {
        products: formattedWishlistedProducts,
      });

      requestAnimationFrame(() => {
        this.wishlistContainer.innerHTML = productCardsMarkup;
        this.attachClickListeners();

        if (typeof swat.initializeActionButtons === 'function') {
          swat.initializeActionButtons('body');
        }

        document.dispatchEvent(new Event('wishlist:rendered'));

        this.wishlistContainer.classList.add('wishlist-rendered');
      });
    });
  }

  attachClickListeners() {
    const addToCartButtons = document.querySelectorAll('#swym-custom-add-toCartBtn');
    const removeBtns = document.querySelectorAll('#swym-remove-productBtn');

    for (const btn of addToCartButtons) {
      btn.addEventListener('click', this.onAddToCartClick.bind(this), { passive: false });
    }

    for (const btn of removeBtns) {
      btn.addEventListener('click', this.onRemoveBtnClick.bind(this), { passive: false });
    }
  }
}

// Register the custom element
customElements.define('swym-wishlist', SwymWishlist);

window.swymRenderWishlist = function (swat) {
  const wishlistElement = document.querySelector('swym-wishlist');
  if (wishlistElement) {
    wishlistElement.renderWishlist(swat);
  } else {
    const tempWishlist = new SwymWishlist();
    tempWishlist.renderWishlist(swat);
  }
};

if (window.SwymCallbacks && typeof window.SwymCallbacks.push === 'function') {
  window.SwymCallbacks.push(window.swymRenderWishlist);
}

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('cart:refresh', function (event) {
    if (window._swat) {
      setTimeout(() => {
        window.swymRenderWishlist(window._swat);
      }, 300);
    }
  });

  document.addEventListener('cart-drawer:open', function () {
    if (window._swat) {
      setTimeout(() => {
        window.swymRenderWishlist(window._swat);

        const count = window._swat ? window._swat.persistedData.upi.length : 0;
        const wishlistCountElements = document.querySelectorAll('.js-wishlist-count');
        wishlistCountElements.forEach((el) => {
          el.textContent = count;
        });

        if (typeof initCartDrawerTabsOnLoad === 'function') {
          initCartDrawerTabsOnLoad();
        } else {
          const wishlistElement = document.querySelector('swym-wishlist');
          if (wishlistElement && typeof wishlistElement.initCartDrawerTabs === 'function') {
            wishlistElement.initCartDrawerTabs();
          }
        }
      }, 300);
    }
  });

  document.addEventListener('shopify:section:load', function () {
    if (window._swat) {
      setTimeout(() => {
        window.swymRenderWishlist(window._swat);
      }, 300);
    }
  });

  (function (xhr) {
    var XHR = XMLHttpRequest.prototype;
    var send = XHR.send;
    XHR.send = function () {
      this.addEventListener('load', function () {
        if (
          this.responseURL &&
          (this.responseURL.includes('/cart/add') ||
            this.responseURL.includes('/cart/change') ||
            this.responseURL.includes('/cart/update') ||
            this.responseURL.includes('/cart/clear'))
        ) {
          if (window._swat) {
            setTimeout(() => {
              window.swymRenderWishlist(window._swat);

              if (typeof window.cartDrawerTabClickHandler === 'function') {
                const tabHeadings = document.querySelectorAll('.js-drawer-heading');
                tabHeadings.forEach(function (heading) {
                  heading.removeEventListener('click', window.cartDrawerTabClickHandler);
                  heading.addEventListener('click', window.cartDrawerTabClickHandler);
                });

                const event = new CustomEvent('cart-drawer:updated');
                document.dispatchEvent(event);
              }
            }, 300);
          }
        }
      });
      return send.apply(this, arguments);
    };
  })(XMLHttpRequest);

  const checkInterval = setInterval(function () {
    const wishlistContainer = document.getElementById('wishlist-items-container');
    if (wishlistContainer && wishlistContainer.children.length === 0) {
      if (window._swat) {
        window.swymRenderWishlist(window._swat);
      }
    }
  }, 2000); // Check every 2 seconds
});
